import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import animations from './animations';
import Heading from "../../elements/Heading";
import ServiceTabDesktop from "../ServiceTabDesktop";
import ServiceBlockDesktop from "../ServiceBlockDesktop";
import ServiceBlockMobile from "../ServiceBlockMobile";

class Services extends Component {

    constructor(props) {
        super(props);

        this.state = {
            services: (props.data.services ? props.data.services : [])
        };

        this.sceneController = null;
        this.desktopTabs = [];
        this.desktopBlocks = [];
        this.mobileBlocks = [];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                services: this.props.data.services
            }, () => {
                if (!this.sceneController) {
                    this.sceneController = animations.initialise(this);
                }
            });
        }
    }
    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setTitleRef(el) {
        this.titleRef = el;
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }
    
    render() {
        const DesktopTabs = this.state.services.map((service, key) => {
            return (
                <ServiceTabDesktop
                    key={key}
                    title={service.title}
                    subTitle={service.subTitle}
                    active={(key === 1)}
                    handleClick={() => animations.switchTab(this, key)}
                    ref={el => this.desktopTabs.push(el)}
                />
            );
        });

        const DesktopBlocks = this.state.services.map((service, key) => {
            return (
                <ServiceBlockDesktop
                    key={key}
                    items={service.items}
                    url={service.url}
                    active={(key === 1)}
                    ref={el => this.desktopBlocks.push(el)}
                />
            );
        });

        const MobileBlocks = this.state.services.map((service, key) => {
            return (
                <ServiceBlockMobile
                    key={key}
                    title={service.title}
                    url={service.url}
                    items={service.items}
                    active={(key === 0)}
                    handleClick={() => animations.switchTab(this, key)}
                    ref={el => this.mobileBlocks.push(el)} />
            );
        });

        return (
            <section className="our-services tabs-section">
                <div className="row">
                    <div className="col-md-5 col-md-offset-2 col-sm-12 text-sm-center text-xs-center">
                        <Heading
                            title={this.props.data.title}
                            subTitle={this.props.data.subTitle}
                            setTitleRef={this.setTitleRef.bind(this)}
                            setSubTitleRef={this.setSubTitleRef.bind(this)}
                        />
                        <div className="services-trigger2" />
                    </div>
                </div>

                <BrowserView>
                    <div className="row no-padding tabs-parent desktop">
                        <div className="col-md-10 col-md-offset-1">
                            <div className="tabs">
                                {DesktopTabs}
                            </div>
                        </div>
                        <div className="clearfix" />
                        {DesktopBlocks}
                    </div>
                </BrowserView>

                <MobileView>
                    <div className="row no-padding mobile">
                        <div className="col-xs-12">
                            <div className="tabs">
                                {MobileBlocks}
                            </div>
                        </div>
                    </div>
                </MobileView>
            </section>
        );   
    }
    
}

export default Services;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Services/Services.js